(function () {
  'use strict';

  function initFaqTabs(root) {
    if (!root || root.dataset.ftInit === 'true') return;
    root.dataset.ftInit = 'true';

    var tabs = Array.from(root.querySelectorAll('[data-ft-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-ft-panel]'));

    function activateTab(tabId) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-ft-tab') === tabId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-ft-panel') === tabId);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.getAttribute('data-ft-tab'));
      });
    });

    root.querySelectorAll('[data-ft-panel]').forEach(function (panel) {
      var items = Array.from(panel.querySelectorAll('[data-ft-item]'));

      items.forEach(function (item) {
        var answer = item.querySelector('.ft-section__answer');
        if (!answer) return;

        item.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          items.forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var otherAnswer = other.querySelector('.ft-section__answer');
            if (otherAnswer) otherAnswer.style.maxHeight = '0px';
          });

          if (!isOpen) {
            item.classList.add('is-open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
          } else {
            item.classList.remove('is-open');
            answer.style.maxHeight = '0px';
          }
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ft-section]').forEach(initFaqTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = document.getElementById('ft-' + e.detail.sectionId);
    if (root) {
      root.dataset.ftInit = 'false';
      initFaqTabs(root);
    }
  });
})();
